import React, { useState } from 'react';
import { ICustomer } from '@/interfaces/customer';
import CustomerRemarkDetail from './customer-remark-detail';
import CustomerRemarkEdit from './customer-remark-edit';

interface IProps {
  data: ICustomer;
}

const CustomerRemark = ({ data }: IProps) => {
  const [isEdit, setIsEdit] = useState(false);
  return (
    <>
      {isEdit ? (
        <CustomerRemarkEdit
          data={data}
          handleCancel={() => setIsEdit(false)}
          handleOk={() => setIsEdit(false)}
        />
      ) : (
        <CustomerRemarkDetail data={data} onEdit={() => setIsEdit(true)} />
      )}
    </>
  );
};

export default CustomerRemark;
